<template>
  <div>
    <BaseTitle :title="$t('form.notification')" />
    <v-card>
      <div class="pa-5 d-flex justiy-space-between align-items section-header active">
        <div class="student-title">{{ $t('content.personal_birthday') }}</div>
      </div>

      <div class="pa-13">
        <div class="succ">
          <div class="succ-content">
            <svg-icon icon="balon" class="ml-16" width="860" height="150" />
            <h1 class="succ-heading mb-5">{{ datas.birthdayText }} , {{ datas.fullName }}</h1>
            <img v-if="datas.imageUrl" :src="datas.imageUrl" class="user-photo" />
            <img v-else :src="require('@/assets/images/sample-user.png')" class="user-photo" />
            <div class="succ-content mt-2">{{ dateName }}</div>
            <div class="succ-content mb-6">{{ datas.birthdayNote }}</div>
            <v-btn color="primary btn-primary-custom" width="260" @click="back()">{{ $t('success.back') }}</v-btn>
          </div>
        </div>
      </div>
    </v-card>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import BaseTitle from '@/components/base/Title';
import moment from 'moment-timezone';

export default {
  name: 'personalBirthday',
  components: {
    BaseTitle
  },
  computed: {
    ...mapGetters({}),
    dateName() {
      return moment(moment(this.datas.birthDate, 'DD-MM-YYYY')).format('dddd , DD MMMM YYYY');
    }
  },
  data: () => ({
    datas: ''
  }),
  methods: {
    getData() {
      this.$store
        .dispatch('Notification/fetchDataBirthday', this.$route.params.id)
        .then(res => (this.datas = res))
        .catch(e => this.$store.dispatch('general/showErrorReqNotification', e));
    },
    back() {
      this.$router.push({ name: 'NotifIndex' });
    }
  },
  created() {
    this.getData();
  }
};
</script>

<style lang="scss" scoped>
.section-header {
  border-radius: 4px 4px 0 0;

  &.active {
    background: #00bf63;
    .student-title {
      color: #fff;
      font-size: 18px;
      font-weight: bold;
    }
  }

  &.disabled {
    background: #acacac;
    pointer-events: none;

    .student-title {
      color: #fff;
    }
  }
}
.succ {
  min-height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #ffffff;
  text-align: center;
  font-family: Montserrat;
  font-weight: 500;

  &-content {
    display: flex;
    align-items: center;
    flex-direction: column;
    padding: 14px;
  }

  &-featured {
    width: 100%;
    margin-bottom: 30px;
  }

  &-heading {
    color: #6d6d6d;
    font-family: Montserrat;
    font-weight: bold;
    font-size: 24px;
  }

  @include query-min-sm() {
    &-featured {
      width: auto;
      height: 340px;
    }
  }
}

.user-photo {
  width: 80px;
  height: 80px;
  overflow: hidden;
  border-radius: 100px;
  margin-right: 10px;
}
</style>
